export enum DAY_STYLES_CLASSNAMES {
	disabled = 'disabled',
	active = 'active',
	idle = 'idle',
	outsideRange = 'outside-range',
	insideSelectedRange = 'inside-selected-range',
}

export interface MarkedDateGroup {
	dates: Date[];
	// CSS color for the day dot and legend dot. Defaults to the action blue.
	color?: string;
	// Legend text below the day grid. Omitted = no legend entry for this group.
	label?: string;
}

export const MARKED_DATE_DEFAULT_COLOR = 'var(--color-icon-action)';

export enum RANGE_OPTION {
	from = 'from',
	to = 'to',
}

export interface CalendarStateInterface {
	fromDateRefVal: string;
	toDateRefVal: string;
	yearInputRefVal: string;
	renderedDate: Date;
	currentRangeOption: RANGE_OPTION;
	prevDate: Date;
	showYearPicker: boolean;
}

export interface CalendarNavigationHandlers {
	onNavigatePrev: () => void;
	onNavigateNext: () => void;
	onNavigateToday: () => void;
	onToggleYearPicker: () => void;
	onSelectYear: (year: number) => void;
	onInputFocus: (event: React.SyntheticEvent<HTMLInputElement>) => void;
	onInputBlur: (event: React.SyntheticEvent<HTMLInputElement>) => void;
}
